import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import TemplatesCreateEditFormAsideItem from './TemplatesCreateEditFormAsideItem';

const styles = theme => ({
  root: {
    height: '100%',
    boxSizing: 'border-box',
    borderRight: `1px solid ${theme.palette.primary.A400}`,
  },
  typography: {
    padding: '28px 24px 8px',
    borderTop: `1px solid ${theme.palette.primary.A100}`,
    '&:first-child': {
      borderTop: 'none',
    },
  },
});

const TemplatesCreateEditFormAside = ({
  boundsSelector,
  onItemStartDrag,
  onItemDrag,
  onItemStopDrag,
  classes,
}) => (
  <aside className={classes.root}>
    <Typography
      className={classes.typography}
      gutterBottom
    >
      Build Custom Questions
    </Typography>
    <List disablePadding>
      <TemplatesCreateEditFormAsideItem
        variant="Textbox"
        primaryText="Free text box"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="MultiLine"
        primaryText="Multiple-line Text box"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Radio"
        primaryText="Radio Button"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Checkbox"
        primaryText="Checkbox"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="DropDown"
        primaryText="Dropdown"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Date"
        primaryText="Date"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Signature"
        primaryText="Signature"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
    </List>
    <Typography
      className={classes.typography}
      gutterBottom
    >
      DME Questions
    </Typography>
    <List disablePadding>
      <TemplatesCreateEditFormAsideItem
        variant="Patient General"
        primaryText="Patient Information"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Patient Insurance"
        primaryText="Patient Insurance"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Patient Vitals"
        primaryText="Patient Vitals"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Patient Prescribers"
        primaryText="Prescribers Information"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
      />
      <TemplatesCreateEditFormAsideItem
        variant="Patient Diagnosis"
        primaryText="Diagnoses"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
        last
      />
      <TemplatesCreateEditFormAsideItem
        variant="HCPCS Codes"
        primaryText="HCPCS Codes"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
        last
      />
      <TemplatesCreateEditFormAsideItem
        variant="Company Information"
        primaryText="Company Information"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
        last
      />
      <TemplatesCreateEditFormAsideItem
        variant="Company Logo"
        primaryText="Company Logo"
        boundsSelector={boundsSelector}
        onStartDrag={onItemStartDrag}
        onDrag={onItemDrag}
        onStopDrag={onItemStopDrag}
        last
      />
    </List>
  </aside>
);

TemplatesCreateEditFormAside.propTypes = {
  boundsSelector: PropTypes.string,
  onItemStartDrag: PropTypes.func,
  onItemDrag: PropTypes.func,
  onItemStopDrag: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

TemplatesCreateEditFormAside.defaultProps = {
  boundsSelector: null,
  onItemStartDrag: null,
  onItemDrag: null,
  onItemStopDrag: null,
};

export default withStyles(styles)(TemplatesCreateEditFormAside);



// WEBPACK FOOTER //
// ./src/components/settings/TemplatesCreateEditForm/TemplatesCreateEditFormAside.js